import firebase from 'firebase'

var config = {
  apiKey: "AIzaSyCXCV3CbpoLvTMRlqSmUR3YhFO3BUq5Pxs",
  authDomain: "cinemahack2020.firebaseapp.com",
  databaseURL: "https://cinemahack2020.firebaseio.com",
  projectId: "cinemahack2020",
  storageBucket: "cinemahack2020.appspot.com",
  messagingSenderId: "396107425167",
  appId: "1:396107425167:web:916ecdacba835cdf4617fa",
  measurementId: "G-RE0Y0NGRFR"
};

var fire = firebase.initializeApp(config);

export default fire;
